module.exports = __webpack_public_path__ + "img/imagemissing0.2bd3d41f.jpg";